import request from '@/util/request';
import qs from 'qs';

/* 系统字典 */
export const getDictApi = (params, options) =>
  request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));

/* 嘱托管理 - 分页接口 */
export const getPageListApi = (params, options) =>
  request.get('/api/nursing/entrust/page', Object.assign({}, options, { params }));

/* 嘱托管理 - 新增 */
export const addApi = (params, options) =>
  request.post('/api/nursing/entrust/save', params, options, { ContentType: 'application/json' });

/* 嘱托管理 - 修改 */
export const updateApi = (params, options) =>
  request.post('/api/nursing/entrust/update', params, options, {
    ContentType: 'application/json',
  });

/* 嘱托管理 - 删除 */
export const removeApi = (params, options) =>
  request.post('/api/nursing/entrust/remove', qs.stringify(params), options);

/* 老人列表 - 下拉 */
export const getElderlyListApi = (params, options) =>
  request.get('/api/nursing/basicInfor/nursinglist', Object.assign({}, options, { params }));
